import type { RouteIdType, Routes } from '@trello/router/routes';
import { routes } from '@trello/router/routes';

import { getRouteIdFromPathname } from './getRouteIdFromPathname';

export function getRouteParamsFromPathname<T extends RouteIdType>(
  pathname: string,
): ReturnType<Routes[T]['getRouteParams']> {
  const routeId = getRouteIdFromPathname(pathname);
  const route = routes[routeId];

  return route.getRouteParams(pathname) as ReturnType<
    Routes[T]['getRouteParams']
  >;
}
